import { render, staticRenderFns } from "./CourseEvents.vue?vue&type=template&id=182f6044&"
import script from "./CourseEvents.vue?vue&type=script&lang=js&"
export * from "./CourseEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports